import { Stack, Typography } from '@mui/material';
import CheckRounded from '@mui/icons-material/CheckRounded';
import CreditIcon from 'src/assets/icons/CreditIcon.svg';
import AiCreditIcon from 'src/assets/icons/AiCreditIcon.svg';
import Amount from './Amount';
import {
  DoneButton,
  StatTile,
  SuccessBadge,
  TileLabel,
} from './styles/SuccessStep.styles';
import {
  AI_CREDIT_INK,
  AI_CREDIT_INK_DARK,
  SuccessStepProps,
  inr,
} from './types';

const SuccessStep = ({ result, mobile, onClose }: SuccessStepProps) => (
  <Stack
    sx={{
      p: mobile ? '6px 20px 24px' : '4px 24px 24px',
      gap: 2,
      alignItems: 'center',
    }}
  >
    <SuccessBadge>
      <CheckRounded sx={{ fontSize: 26 }} />
    </SuccessBadge>
    <Stack sx={{ gap: 0.75, textAlign: 'center' }}>
      <Typography sx={{ fontSize: 17, fontWeight: 800 }}>
        {inr(result.added)} AI Credits added
      </Typography>
      <Typography
        sx={{ fontSize: 12.8, color: 'text.secondary', maxWidth: 280 }}
      >
        {result.charged > 0
          ? `${inr(result.charged)} Credits were deducted from your vault.`
          : 'Included with your plan — no Credits were deducted.'}
      </Typography>
    </Stack>
    <Stack direction="row" sx={{ gap: 1.25, width: '100%' }}>
      <StatTile>
        <TileLabel>AI Credits</TileLabel>
        <Amount
          icon={AiCreditIcon}
          size={18}
          fontSize={16}
          color={AI_CREDIT_INK}
          colorDark={AI_CREDIT_INK_DARK}
        >
          {inr(result.aiCredits)}
        </Amount>
      </StatTile>
      <StatTile>
        <TileLabel>Credits left</TileLabel>
        <Amount icon={CreditIcon} size={18} fontSize={16}>
          {inr(result.credits)}
        </Amount>
      </StatTile>
    </Stack>
    <DoneButton onClick={onClose}>Done</DoneButton>
  </Stack>
);

export default SuccessStep;
